import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import QRCode from 'qrcode';

const GuestPhotos = () => {
  const { t } = useLanguage();
  const [qrCodeUrl, setQrCodeUrl] = useState('');
  const [isMobile, setIsMobile] = useState(false);
  
  const googlePhotosLink = 'https://photos.app.goo.gl/iQsKCDjb5sAz8Snv5';

  // Generate QR code
  useEffect(() => {
    const generateQR = async () => {
      try {
        const qrCodeDataURL = await QRCode.toDataURL(googlePhotosLink, {
          width: 200,
          margin: 2,
          color: {
            dark: '#5D7A8C',
            light: '#FFFFFF'
          }
        });
        setQrCodeUrl(qrCodeDataURL);
      } catch (error) {
        console.error('Error generating QR code:', error);
      }
    };
    
    generateQR();
  }, []);

  // Mobile detection
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleUploadClick = () => {
    window.open(googlePhotosLink, '_blank');
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.8,
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6 }
    }
  };

  const buttonVariants = {
    rest: { scale: 1 },
    hover: { 
      scale: 1.05,
      transition: { duration: 0.2 }
    },
    tap: { scale: 0.95 }
  };

  return (
    <section id="guest-photos" className="guest-photos-landing">
      <div className="guest-photos-background">
        <div className="background-overlay"></div>
      </div>
      
      <div className="container">
        <motion.div
          className="guest-photos-content"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {/* Main Content */}
          <motion.div 
            variants={itemVariants}
            className="text-center guest-photos-main"
          >
            {/* Main Title */}
            <motion.h1 
              className="guest-photos-title"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              {t('guestPhotos.catchPhrase')}
            </motion.h1>

            {/* Subtitle */}
            <motion.div 
              className="guest-photos-subtitle lead mb-4"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              {t('guestPhotos.additionalInfo')}
            </motion.div>

            {/* QR Code Container */}
            <motion.div 
              className="qr-code-container"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.3 }}
            >
                {qrCodeUrl && (
                  <img 
                    src={qrCodeUrl} 
                    alt="QR Code" 
                    className="qr-code"
                    onClick={handleUploadClick}
                    style={{ cursor: 'pointer' }}
                  />
                )}
                <p className="mt-3">
                  {t('guestPhotos.qrDescription')}
                </p>
            </motion.div>

          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default GuestPhotos;
